import { useState } from "react";
import Loader from "../../components/main/Loader";
import { initialParams, IPagination } from "../../helpers/PaginationHelper";
import { useGetUserRoleQuery } from "../../store/services/LookUpService";
import ReportCallsFilters from "../../components/filters/ReportCallsFilters";
import { AdapterReportFilterCalls } from "../../helpers/adapter/filters/AdapterFilterReportCalls";
import { useGetReportChiamateMutation } from "../../store/services/ReportService";
import { toast } from "react-toastify";
import { saveAs } from 'file-saver';

export default function ReportCalls() {
    const [queryParams, setQueryParams] = useState<IPagination>(initialParams);
    const [filterParams, setFilterParams] = useState<any>(null);
    let { data: operatoreData, isLoading: isLoadingOp } = useGetUserRoleQuery({role: 'Operatore' });
    let { data: supervisoreData, isLoading: isLoadingSup } = useGetUserRoleQuery({role: 'Supervisore' });
    const [getReportChiamate, requestReport] = useGetReportChiamateMutation()
    

    const handleSetFilter = async (dataFilter: any) => {
        const mapFilter = AdapterReportFilterCalls(dataFilter)
        setFilterParams(mapFilter);
        setQueryParams(initialParams);
        let result: any = await getReportChiamate(mapFilter);

        if ('error' in result) {
            console.log('ERROR DOWNLOAD')
        } else {
            saveAs(result?.data, `StatisticheChiamate_${Date.now()}.xlsx`)
            toast.success(`Report scaricato`);
        }
    }

    return(
        <>
            { (isLoadingOp || isLoadingSup || requestReport.isLoading) ? <Loader /> : null}
            <ReportCallsFilters methodParent={handleSetFilter} operatoreData={operatoreData} supervisoreData={supervisoreData} />
            {requestReport?.isError 
                ? 
                <div className="mt-8 bg-red-100 border-l-4 border-red-500 text-red-700 p-4" role="alert">
                    <p className="font-bold">Attenzione</p>
                    <p>Nessun risultato presente per i parametri selezionati</p>
                </div>
                : null
            }
        </>
    )
}